import { getHoverChartImg } from '../app/shared/hover-chart'
import { getSanitizedTicker } from '../app/shared/ticker-sanitizer'

declare global {
  interface Window {
    FLibs: any
  }
}
window.FLibs = window.FLibs || {}
window.FLibs.getHoverChartImg = getHoverChartImg
window.FLibs.getSanitizedTicker = getSanitizedTicker
